export const sigFigs100 = (value: number) => Math.round(value * 100) / 100
export const wholeNumber = (value: number) => Math.round(value)
export const roundFloat = (value: number | undefined, sf: number = 2) => {
  const orderValue = 10 ** sf
  return typeof value === 'undefined' ? undefined : Math.round(value * orderValue) / orderValue
}
